// components/workshop/src/components/workshop/workshopCapacityUtils.js
export function normalizeWorkshopSlug(raw = "") {
  const s = String(raw)
    .toLowerCase()
    .trim()
    .replace(/[\s\-_]/g, "")
    .replace(/ø/g, "o")
    .replace(/æ/g, "ae")
    .replace(/å/g, "a");

  if (!s) return "";

  if (s.includes("roykensykkel")) return "roykensykkelverksted";
  if (s.includes("sport1royken") || (s.includes("sport1") && s.includes("royken"))) return "sport1royken";
  if (s.includes("slemmestad")) return "sport1slemmestad";
  if (s.includes("royken")) return "sport1royken";

  return s;
}

export function isoDate(d) {
  const x = new Date(d);
  const y = x.getFullYear();
  const m = String(x.getMonth() + 1).padStart(2, "0");
  const day = String(x.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

export function weekStartISO(d) {
  const x = new Date(d);
  const day = x.getDay();
  const diff = (day === 0 ? -6 : 1) - day;
  x.setDate(x.getDate() + diff);
  return isoDate(x);
}

export function getWeekNumber(dateInput) {
  const d = new Date(dateInput);
  const target = new Date(d.valueOf());
  const dayNr = (d.getDay() + 6) % 7;
  target.setDate(target.getDate() - dayNr + 3);
  const firstThursday = new Date(target.getFullYear(), 0, 4);
  const diff = target - firstThursday;
  return 1 + Math.round(diff / (7 * 24 * 60 * 60 * 1000));
}

export function fmtMinutes(m) {
  const val = Math.max(0, Number(m) || 0);
  const h = Math.floor(val / 60);
  const min = val % 60;
  if (h && min) return `${h} t ${min} min`;
  if (h) return `${h} t`;
  return `${min} min`;
}

export function prettifyStoreName(slug) {
  const norm = normalizeWorkshopSlug(slug);

  if (norm === "sport1royken") return "Sport 1 Røyken";
  if (norm === "roykensykkelverksted") return "Røyken Sykkelverksted";
  if (norm === "sport1slemmestad") return "Sport 1 Slemmestad";

  return slug;
}

export function getWeekdayNameNo(dateInput) {
  return new Date(dateInput).toLocaleDateString("no-NO", {
    weekday: "long",
  });
}

// Fast timepris for tidsstyrt arbeid (reklamasjon og gratisarbeid), brukt
// både i faktureringsgrunnlaget og i ukesomsetningen.
export const TIMEPRIS = 950;

export function tidsstyrtVerdi(min) {
  return Math.round((Number(min || 0) / 60) * TIMEPRIS);
}

export function normalizeEnumDay(day = "") {
  return String(day)
    .toLowerCase()
    .replace(/ø/g, "o")
    .replace(/å/g, "a")
    .trim();
}

export const ALL_STORES = ["sport1royken", "sport1slemmestad", "roykensykkelverksted"];

// Omsetningsmål pr. arbeidsdag pr. butikk. Brukes til å utlede ukes- og
// månedsbudsjett (5-dagers uke) og til å regne ut hvor mye stengte dager
// trekker ned målet.
export const DAGSMÅL_PER_BUTIKK = {
  sport1royken: 4000,
  sport1slemmestad: 1000,
  roykensykkelverksted: 0,
};

export function addDays(date, n) {
  const d = new Date(date);
  d.setDate(d.getDate() + n);
  return d;
}

export function fmtKr(amount) {
  const n = Number(amount) || 0;
  return n > 0 ? `${n.toLocaleString("nb-NO")} kr` : "—";
}

export function getWeekOverrideForStore(overrides = [], storeSlug, weekIso) {
  const wanted = normalizeWorkshopSlug(storeSlug);
  return overrides.find((o) => {
    const loc = normalizeWorkshopSlug(o?.lokasjon || "");
    if (loc !== wanted) return false;
    if (!o?.uke) return false;
    return weekStartISO(o.uke) === weekIso;
  });
}

export function getDateOverrideForStore(overrides = [], storeSlug, dateIso) {
  const wanted = normalizeWorkshopSlug(storeSlug);
  return overrides.find((o) => {
    const loc = normalizeWorkshopSlug(o?.lokasjon || "");
    if (loc !== wanted) return false;
    return o?.dato === dateIso;
  });
}

export function isDateClosed(overrides, storeSlug, dateIso, weekIso) {
  const weekOv = getWeekOverrideForStore(overrides, storeSlug, weekIso);
  if (weekOv?.stengt) return true;
  const dateOv = getDateOverrideForStore(overrides, storeSlug, dateIso);
  return !!dateOv?.stengt;
}